export default __webpack_public_path__ + "static/media/icp-logo.013d31f8.png";